import React, { useState, useEffect, useRef } from 'react';
import { Checkbox, Fieldset, Legend } from '@flixbus/honeycomb-react';
import { useVoucherFormContext } from '../../Context';
import { FREE_ANCILLARIES, FreeAncillariesRule } from '../../../../types/Rules';

const FreeAncillaries = () => {
  const {
    formState: {
      payload: { rules },
    },
    handleRuleChange,
  } = useVoucherFormContext();

  const ruleValue = rules.find(r => r.type === 'free_ancillaries') as
    | FreeAncillariesRule
    | undefined;

  const [selectedAncillaries, setSelectedAncillaries] = useState<Set<FREE_ANCILLARIES>>(
    new Set(ruleValue?.ancillaries),
  );

  const handleRuleChangeRef = useRef(handleRuleChange);

  useEffect(() => {
    handleRuleChangeRef.current = handleRuleChange;
  }, [handleRuleChange]);

  useEffect(() => {
    handleRuleChangeRef.current(
      {
        type: 'free_ancillaries',
        ancillaries: Array.from(selectedAncillaries),
      },
      selectedAncillaries.size === 0,
    );
  }, [selectedAncillaries]);

  const handleCheckboxChange = (ancillary: FREE_ANCILLARIES) => {
    setSelectedAncillaries(prevSelected => {
      const updated = new Set(prevSelected);
      if (updated.has(ancillary)) {
        updated.delete(ancillary);
      } else {
        updated.add(ancillary);
      }
      return updated;
    });
  };

  return (
    <Fieldset>
      <Legend>Free Ancillaries</Legend>
      <Checkbox
        label='Platform fee'
        id='platform-fee'
        value={FREE_ANCILLARIES.PLATFORM_FEE}
        checked={selectedAncillaries.has(FREE_ANCILLARIES.PLATFORM_FEE)}
        onChange={() => handleCheckboxChange(FREE_ANCILLARIES.PLATFORM_FEE)}
      />
      <Checkbox
        label='Seat reservation'
        id='seat-reservation'
        value={FREE_ANCILLARIES.SEAT_RESERVATION}
        checked={selectedAncillaries.has(FREE_ANCILLARIES.SEAT_RESERVATION)}
        onChange={() => handleCheckboxChange(FREE_ANCILLARIES.SEAT_RESERVATION)}
      />
    </Fieldset>
  );
};

export default FreeAncillaries;
